import {
    Box,
    componentStyles,
    useColors,
} from "@mallardbay/lib-react-components"
import React, { type PropsWithChildren } from "react"

import ResponsiveBlock from "~components/shared/responsive-block"

interface CheckoutRootProps extends PropsWithChildren {
    readonly isFlexContainer?: boolean
    readonly isWidget?: boolean
}

interface CheckoutLeftContainerProps extends PropsWithChildren {
    readonly isWidget?: boolean
}

interface CheckoutRightContainerProps extends PropsWithChildren {
    readonly isWidget?: boolean
}

export function CheckoutRootContainer({
    isFlexContainer = true,
    isWidget,
    children,
}: CheckoutRootProps) {
    const styles = useStyles({ isFlexContainer, isWidget })

    return (
        <ResponsiveBlock noPadding={isWidget}>
            <Box style={styles.root}>{children}</Box>
        </ResponsiveBlock>
    )
}

export function CheckoutLeftContainer({
    isWidget,
    children,
}: CheckoutLeftContainerProps) {
    const styles = useStyles({ isWidget })

    return <Box style={styles.left}>{children}</Box>
}

export function CheckoutRightContainer({
    isWidget,
    children,
}: CheckoutRightContainerProps) {
    const styles = useStyles({ isWidget })

    return (
        <Box style={styles.right}>
            <Box style={styles.stickyContainer}>{children}</Box>
        </Box>
    )
}

function useStyles({
    isFlexContainer,
    isWidget,
}: { isFlexContainer?: boolean; isWidget?: boolean } = {}) {
    const colors = useColors()

    return componentStyles({
        root: {
            display: isFlexContainer ? "flex" : "block",
            color: colors.contentPrimary,
            paddingTop: isWidget ? "0" : "10px",
            paddingBottom: { base: "32px", md: "48px" },
        },
        left: {
            flex: 1,
            boxSizing: "border-box",
            paddingTop: isWidget ? "0" : "16px",
        },
        right: {
            display: { base: "none", md: "initial" },
            width: { base: "100%", md: "400px", lg: "450px" },
            minWidth: { base: "100%", md: "400px", lg: "450px" },
            marginLeft: { md: "24px", lg: "48px" },
        },
        stickyContainer: {
            top: "80px",
            position: "sticky",
            boxSizing: "border-box",
            padding: isWidget ? "0" : "24px 0",
        },
    })
}
